type Props = {
  size: number;
};

const IconPrevious = ({size}: Props) => {
  return (
    <svg
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path
        d="M28.67 1.85l-14 12.63a2.05 2.05 0 000 3.03l14 12.64A2 2 0 0032 28.64V3.36a2 2 0 00-3.33-1.51zM0 0h9.33v32H0z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconPrevious;
